import { useState } from 'react'
import Button from 'baby-ui/foundation/Button/Button'
import { Accordion } from 'components/accordion'
import classNames from 'classnames'
import { useStyles } from './FrequentlyAskedQuestions.styles'
import { Question } from './FrequentlyAskedQuestions.types'

interface FrequentlyAskedQuestionsProps {
  questions: Question[]
  headerVariant: 'primary' | 'secondary'
  accordion?: boolean
}

interface AccordionTriggerProps {
  onClick: () => void
  isOpen: boolean
}

const FrequentlyAskedQuestions = ({
  questions = [],
  headerVariant = 'primary',
  accordion = false,
}: FrequentlyAskedQuestionsProps) => {
  const classes = useStyles({ headerVariant })
  const [activeQuestionIndex, setActiveQuestionIndex] = useState<number | null>(
    null
  )

  const handleTriggerClick = (index: number, callback: () => void) => {
    // Ensure only one question is open at a time
    if (activeQuestionIndex === index) setActiveQuestionIndex(null)
    else setActiveQuestionIndex(index)
    callback()
  }

  return (
    <div className={classes.frequentlyAskedQuestionSection}>
      <div>
        <h2 className={classes.sectionHeader}>Frequently Asked Questions</h2>
        {headerVariant === 'secondary' && <hr />}
      </div>
      {questions.map((question, index) => (
        <div className={classes.questionContainer} key={question.id}>
          {accordion ? (
            <Accordion
              defaultOpen={activeQuestionIndex === index}
              trigger={({ onClick, isOpen }: AccordionTriggerProps) => (
                <Button
                  classes={{
                    root: classes.collapsibleHeader,
                    label: classes.collapsibleHeaderLabel,
                  }}
                  type="button"
                  onClick={() => handleTriggerClick(index, onClick)}
                >
                  <h3 className={classes.question}>{question.question}</h3>
                  <img
                    alt={`Collapsible question ${
                      isOpen ? 'closed' : 'open'
                    } icon`}
                    className={classNames(classes.chevron, {
                      [classes.rotate]: isOpen,
                    })}
                    src="https://images.babylist.com/image/upload/v1686326413/Dynamic%20Landing%20Pages/FAQ_chevron_down.svg"
                  />
                </Button>
              )}
            >
              <p
                className={classNames(classes.answer, classes.accordionAnswer)}
                dangerouslySetInnerHTML={{ __html: question.answer }}
              />
            </Accordion>
          ) : (
            <>
              <h3 className={classes.question}>{question.question}</h3>
              <p
                className={classes.answer}
                dangerouslySetInnerHTML={{ __html: question.answer }}
              />
            </>
          )}
        </div>
      ))}
    </div>
  )
}

export default FrequentlyAskedQuestions
